import { useState } from "react";
import ItemsCarousel from 'react-items-carousel';

const SinglePageShimmer = () => {

    const [activeItemIndex, setActiveItemIndex] = useState(0);
    const [activeThumbIndex, setActiveThumbIndex] = useState(0);
    return (<div className="col-12 col-xl-9 d-flex flex-wrap">
        <div className="col-12 col-md-6">
            <ItemsCarousel
                key={'first-shimmer'}
                requestToChangeActive={setActiveItemIndex}
                activeItemIndex={activeItemIndex}
                numberOfCards={1}
                gutter={20}
                leftChevron={<div className="chevron"><p>&#8249;</p></div>}
                rightChevron={<div className="chevron"><p>&#8250;</p></div>}
                disableSwipe={true}
                chevronWidth={40}
                alwaysShowChevrons={false}
            >
                {Array(4).fill().map((_, index) => {
                    return (
                        <div key={index} className="shine" style={{ width: "100%", height: 400 }}>
                        </div>
                    );
                })}
            </ItemsCarousel>
            <div className="py-2">
                <ItemsCarousel
                    key={'second-shimmer'}
                    requestToChangeActive={setActiveThumbIndex}
                    activeItemIndex={activeThumbIndex}
                    numberOfCards={4}
                    leftChevron={<div className="chevron"><p>&#8249;</p></div>}
                    rightChevron={<div className="chevron"><p>&#8250;</p></div>}
                    disableSwipe={false}
                    chevronWidth={40}
                >
                    {Array(4).fill().map((_, index) => {
                        return (
                            <div key={index} style={{ border: activeItemIndex === index ? "2px solid #ec008c" : "2px solid transparent" }} className="mt-2 ">
                                <div key={index} className="shine" style={{ width: "100%", height: 75 }}>
                                </div>
                            </div>


                        );
                    })}
                </ItemsCarousel>
            </div>
        </div>
        <div className="col-12 col-md-6">
            <div className="d-flex flex-column ps-0 ps-md-3">
                <div className="shine mb-2" style={{ width: "70%", height: 35 }}>
                </div>

                <div className="shine mb-2" style={{ width: "30%", height: 15 }}>
                </div>
                <div className="shine mb-2" style={{ width: "50%", height: 30 }}>
                </div>
                <div className='d-flex flex-wrap mb-2'>

                    <div className="shine me-2" style={{ width: "40%", height: 25 }}>
                    </div>

                    <div className="shine" style={{ width: "40%", height: 25 }}>
                    </div>
                </div>
                <div className="mb-4">
                    <div className="shine" style={{ width: "100%", height: 5 }}></div>
                    <div className="shine" style={{ width: "90%", height: 5 }}></div>
                    <div className="shine" style={{ width: "80%", height: 5 }}></div>
                    <div className="shine" style={{ width: "95%", height: 5 }}></div>
                    <div className="shine" style={{ width: "100%", height: 5 }}></div>
                    <div className="shine" style={{ width: "90%", height: 5 }}></div>
                    <div className="shine" style={{ width: "80%", height: 5 }}></div>
                    <div className="shine" style={{ width: "90%", height: 5 }}></div>
                    <div className="shine" style={{ width: "50%", height: 5 }}></div>
                </div>
                <div className='d-flex flex-wrap mb-4'>
                    <div className="shine me-2" style={{ width: "40%", height: 20 }}>
                    </div>

                    <div className="shine" style={{ width: "40%", height: 20 }}>
                    </div>
                </div>
                <div className='p-2 border shadow rounded'>
                    <div className="shine" style={{ width: "40%", height: 10 }}></div>
                    <div className="shine" style={{ width: "60%", height: 10 }}></div>
                    <div className="shine" style={{ width: "50%", height: 10 }}></div>
                </div>
            </div>
        </div>
    </div>);
}

export default SinglePageShimmer;